import { gql, useMutation } from "@apollo/client"
import { InjectedOptions } from "@oysterhr/core"
import { CreateCompanyValuationInput, CreateCompanyValuationPayload } from "@oysterhr/schema"

const EQUITY_CREATE_COMPANY_VALUATION_MUTATION = gql`
  mutation EquityCreateCompanyValuation(
    $companyId: ID!
    $valuation: Float
    $valuationCurrency: String
    $effectiveDate: ISO8601Date
    $equityGrantId: ID
  ) {
    equityCreateCompanyValuation(
      input: {
        companyId: $companyId
        valuation: $valuation
        valuationCurrency: $valuationCurrency
        effectiveDate: $effectiveDate
        equityGrantId: $equityGrantId
      }
    ) {
      equityCompanyValuation {
        id
      }
      errors
    }
  }
`

type MutationPayload = { equityCreateCompanyValuation: CreateCompanyValuationPayload }

export const useCreateCompanyValuation = (
  options?: InjectedOptions<MutationPayload, CreateCompanyValuationInput>,
) => useMutation(EQUITY_CREATE_COMPANY_VALUATION_MUTATION, options)
